import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ChangesPendingModalComponent, type ChangesPendingModalProps,
} from './changesPendingModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ChangesPending: ChangesPendingModalProps;
  }
}
modalRenderer.register('ChangesPending', ChangesPendingModalComponent);
